import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import {initReactI18next} from 'react-i18next';

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(Backend)
  .init({
    lng: 'en',
    useSuspense: true,
    keySeparator: false,
    backend: {
      loadPath:
        (true ? '/locales/' : '/public/locales/') + '{{lng}}/{{ns}}.json',
    },
    interpolation: {
      escapeValue: false,
    },
  });

export const loadModuleTxFile = async (module) => {
  await i18n.loadNamespaces(module);
};

export default i18n;
